import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { setPlayerStats } from '../../../store/playerSlice';
import styles from './AccountHome.module.css';

const AccountHome = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const username = useSelector((state) => state.auth.username || state.user.username);
    const [statsError, setStatsError] = useState(null);
    const [statsLoading, setStatsLoading] = useState(false);

    const handleManageAccount = () => {
        navigate('/manageaccount');
    };

    const handleSeeStats = async () => {
        setStatsError(null);
        setStatsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/c/getstats/`, {
                params: { username },
            });
            const player = response.data.player_stats || {};
            dispatch(setPlayerStats({
                totalGamesPlayed: player.total_games_played,
                totalGamesCompleted: player.total_games_completed,
                wins: player.wins,
                losses: player.losses,
                winningPercentage: player.winning_percentage,
                saves: player.saves,
                savesPerGame: player.saves_per_game,
                halfcups: player.half_cups,
                halfcupsPerGame: player.half_cups_per_game,
                fullCups: player.full_cups,
                fullCupsPerGame: player.full_cups_per_game,
                ownCups: player.own_cups,
                ownCupsPerGame: player.own_cups_per_game,
                totalCups: player.total_cups,
                totalCupsPerGame: player.total_cups_per_game,
                lapsGiven: player.laps_given,
                lapsReceived: player.laps_received,
                totalCupsFor: player.total_cups_for,
                totalCupsAgainst: player.total_cups_against,
                cups: player.cups,
            }));
            navigate('/seestats');
        } catch {
            setStatsError('Failed to load stats. Please try again.');
        } finally {
            setStatsLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <button className={styles.backButton} onClick={() => navigate(-1)}>← Back</button>
            <h1 className={styles.title}>Hello, {username}!</h1>
            <p className={styles.subtitle}>What would you like to do?</p>
            {statsError && <p className={styles.errorMessage}>{statsError}</p>}
            <div className={styles.buttonContainer}>
                <button className={`${styles.button} ${styles.primaryButton}`} onClick={handleSeeStats} disabled={statsLoading}>
                    {statsLoading ? 'Loading…' : 'See Stats'}
                </button>
                <button className={`${styles.button} ${styles.secondaryButton}`} onClick={handleManageAccount}>Manage Account</button>
            </div>
        </div>
    );
};

export default AccountHome;
